import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import {
  AddNewCertificate,
  fetchAllData,
} from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function CertificateAdd({ certificateAdd, setCertificateAdd }) {
  const [mainPhoto, setMainPhoto] = useState("");
  const [photoFile, setPhotoFile] = useState();
  const [details, setDetails] = useState("");
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      setMainPhoto(reader.result);
    };
    setPhotoFile(file);
    reader.onerror = (error) => {
      // Handle file reading error
      console.error("File reading error:", error);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const saveNewCertificate = () => {
    dispatch(AddNewCertificate({ details, photoFile }));
    setMainPhoto("");
    setDetails("");
    toast.info("Adding Certificate...", { autoClose: false });
    setCertificateAdd(false);
  };
  return (
    certificateAdd && (
      <div className="certificate-add-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setCertificateAdd(false)}
        ></div>
        <div className="container ">
          <div className="title">اضافه شهاده جديده</div>
          <label
            htmlFor="add-image"
            className={mainPhoto ? `image` : `image none`}
          >
            <img src={mainPhoto ? `${mainPhoto}` : `/images/add.png`} alt="" />
          </label>
          <input
            type="file"
            onChange={handleFileChange}
            name=""
            accept="image/*"
            id="add-image"
            style={{ display: "none" }}
          />
          <div className="text">
            <input
              type="text"
              placeholder="Details Of Certificate"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => saveNewCertificate()}>
            اضافه
          </div>
        </div>
      </div>
    )
  );
}
